<script lang="tsx">

import {defineComponent, onMounted, onUnmounted, Teleport} from 'vue';

export default defineComponent({
  name: 'Modal',
  inheritAttrs: false,
  components: {},
  setup(props, context) {

    onMounted(() => {
      document.body.classList.add("modal-open")
    })
    onUnmounted(() => {
      document.body.classList.remove("modal-open")
    })

    return () =>
      <Teleport to="body #app .app">
        <div class="modal" {...context.attrs}>
          {context.slots.default?.()}
        </div>
      </Teleport>
  }
});
</script>

<style lang="scss">
@import "src/css/common/index";

body.modal-open {
  overflow: hidden;
}

</style>

<style lang="scss" scoped>
@import "src/css/common/index";

@include important {
  .modal {
    position: fixed;
    width: 100vw;
    height: calc(100vh);
    z-index: 999;
    top: 0;
    left: 0;
    pointer-events: none;

    & > ::v-deep(*) {
      pointer-events: all;
    }
  }

}
</style>
